import { clientApi } from "@/utils/api";
import {
  TSearchRsoLearnerReqDto,
  TSearchRsoLearnerResDto,
} from "@/api/services/main/rso-learner/dtos/search-rso-learner.dto";

// 取り込み元 Visa の特定技能外国人一覧。publicId はBE側で有効連携から解決するためFEは送らない。
// RSO: /rso/... (所属機関横断) / Company: /company/... (自社のみ・所属機関条件は無視される)。
// 配列パラメータ (employmentStatus / industryNames / nationalityNames 等) は axios 既定の
// `key[]=value` 形式で送る必要があるため、手動URL組立ではなく params で渡す。
export const searchRsoLearnersApi = async (
  req: TSearchRsoLearnerReqDto,
  isCompanyUser: boolean,
): Promise<TSearchRsoLearnerResDto> => {
  const path = isCompanyUser
    ? "/company/study-link-requests/employees"
    : "/rso/study-link-requests/employees";
  const { data } = await clientApi.get<TSearchRsoLearnerResDto>(path, { params: req });
  return data;
};
